import React, { ChangeEvent } from 'react';
import { Box, Checkbox, Stack } from '@chakra-ui/core';
import Star5 from '../../../../assets/img/star5.png';
import Star4 from '../../../../assets/img/star4.png';
import Star3 from '../../../../assets/img/star3.png';
import Star2 from '../../../../assets/img/star2.png';
import Star1 from '../../../../assets/img/star1.png';
import { useSeekersFilters } from '../filters/SeekersFiltersContext';
import { SearchAndSortTypes } from '../filters/seekersFiltersContextValueType';
import { SearchAndSortProps } from './searchAndSortType';

export const RatingsView = ({ tempSearchAndSortType, setTempSearchAndSortTypes }: SearchAndSortProps): JSX.Element => {
  const { setIsFromSearchAndSort } = useSeekersFilters();

  const onHandleRate = (searchAndSort: SearchAndSortTypes) => {
    setIsFromSearchAndSort(true);
    setTempSearchAndSortTypes({ ...searchAndSort });
  };

  return (
    <Box>
      <Stack direction="column">
        <Checkbox
          data-testid="ratingCheckBox1"
          isChecked={tempSearchAndSortType.rating[0] === 5}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            const updatedRating = [...tempSearchAndSortType.rating];
            updatedRating[0] = e.target.checked ? 5 : 0;
            const updatedFilters = {
              ...tempSearchAndSortType,
              rating: updatedRating,
            };
            onHandleRate(updatedFilters);

            // if (e.target.checked) {
            //   tempSearchAndSortType.rating[0] = 5;
            //   onHandleRate(tempSearchAndSortType);
            // } else {
            //   tempSearchAndSortType.rating[0] = 0;
            //   onHandleRate(tempSearchAndSortType);
            // }
          }}
        >
          <img src={Star5} alt="star5" />
        </Checkbox>
        <Checkbox
          data-testid="ratingCheckBox2"
          isChecked={tempSearchAndSortType.rating[1] === 4}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            const updatedRating = [...tempSearchAndSortType.rating];
            updatedRating[1] = e.target.checked ? 4 : 0;
            const updatedFilters = {
              ...tempSearchAndSortType,
              rating: updatedRating,
            };
            onHandleRate(updatedFilters);
          }}
        >
          <img src={Star4} alt="star4" />
        </Checkbox>
        <Checkbox
          data-testid="ratingCheckBox3"
          isChecked={tempSearchAndSortType.rating[2] === 3}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            const updatedRating = [...tempSearchAndSortType.rating];
            updatedRating[2] = e.target.checked ? 3 : 0;
            const updatedFilters = {
              ...tempSearchAndSortType,
              rating: updatedRating,
            };
            onHandleRate(updatedFilters);
          }}
        >
          <img src={Star3} alt="star3" />
        </Checkbox>
        <Checkbox
          data-testid="ratingCheckBox4"
          isChecked={tempSearchAndSortType.rating[3] === 2}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            const updatedRating = [...tempSearchAndSortType.rating];
            updatedRating[3] = e.target.checked ? 2 : 0;
            const updatedFilters = {
              ...tempSearchAndSortType,
              rating: updatedRating,
            };
            onHandleRate(updatedFilters);
          }}
        >
          <img src={Star2} alt="star2" />
        </Checkbox>
        <Checkbox
          data-testid="ratingCheckBox5"
          isChecked={tempSearchAndSortType.rating[4] === 1}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            const updatedRating = [...tempSearchAndSortType.rating];
            updatedRating[4] = e.target.checked ? 1 : 0;
            const updatedFilters = {
              ...tempSearchAndSortType,
              rating: updatedRating,
            };
            onHandleRate(updatedFilters);
          }}
        >
          <img src={Star1} alt="star1" />
        </Checkbox>
      </Stack>
    </Box>
  );
};
